/**
 * Script Evaluation 优化工具
 * 专门针对减少 JavaScript 执行时间
 * 目标: 从 969ms 降到 < 500ms
 */

/**
 * 1. 延迟非关键JavaScript执行
 */
export const deferNonCriticalJS = () => {
  if (typeof window === 'undefined') return;

  // 延迟加载AOS动画库（非关键）
  const deferAOS = () => {
    setTimeout(() => {
      if (window.AOS) {
        // AOS已经加载，但延迟初始化
        console.log('⏱️ 延迟初始化AOS动画');
      }
    }, 3000); // 3秒后再初始化动画
  };

  // 页面加载完成后执行
  window.addEventListener('load', deferAOS);
};

/**
 * 2. 使用requestIdleCallback延迟执行非关键任务
 */
export const scheduleNonCriticalTasks = () => {
  if (typeof window === 'undefined') return;

  const requestIdleCallback = window.requestIdleCallback || window.setTimeout;

  // 延迟执行非关键任务
  const tasks = [];

  // 示例：延迟初始化某些功能
  requestIdleCallback(
    () => {
      console.log('⏱️ 空闲时间执行非关键任务');
      tasks.forEach((task) => task());
    },
    { timeout: 2000 }
  );
};

/**
 * 3. 分解长时间运行的JavaScript任务
 */
export const breakLongTasks = () => {
  if (typeof window === 'undefined') return;

  // 使用MessageChannel分解长任务
  let scheduledTasks = [];
  const channel = new MessageChannel();

  channel.port1.onmessage = () => {
    const task = scheduledTasks.shift();
    if (task) {
      task();
    }
  };

  window.scheduleTask = (task) => {
    scheduledTasks.push(task);
    channel.port2.postMessage(null);
  };
};

/**
 * 4. 优化React组件渲染
 * 这部分需要在组件代码中实现，这里只提供监控
 */
export const monitorComponentRender = () => {
  if (typeof window === 'undefined') return;

  // 检测React DevTools
  if (window.__REACT_DEVTOOLS_GLOBAL_HOOK__) {
    console.log('💡 提示: 使用React.memo优化组件重复渲染');
  }
};

/**
 * 5. 减少初始化时的JavaScript执行
 */
export const optimizeInitialization = () => {
  if (typeof window === 'undefined') return;

  // 记录初始化开始时间
  const initStart = performance.now();

  // 延迟非关键初始化
  window.addEventListener('load', () => {
    const initEnd = performance.now();
    const initTime = Math.round(initEnd - initStart);

    console.log(`📊 页面初始化时间: ${initTime}ms`);

    if (initTime > 1000) {
      console.warn('⚠️ 初始化时间过长，建议延迟部分功能');
    }
  });
};

/**
 * 初始化Script Evaluation优化
 */
export const initScriptEvaluationOptimization = () => {
  if (typeof window === 'undefined') return;

  console.log('🚀 启动Script Evaluation优化...');

  try {
    deferNonCriticalJS();
    scheduleNonCriticalTasks();
    breakLongTasks();
    monitorComponentRender();
    optimizeInitialization();

    console.log('✅ Script Evaluation优化已启动');
  } catch (error) {
    console.warn('Script Evaluation优化失败:', error);
  }
};
